import { chartConfig } from "../chart.commonConfig";
import { isValidArray } from "../../../../helper";

export const PROJECT_STAGE_WISE_PENDING_ISSUES_RESPONSIVE_CHART_HELPER = data => {
  const BAR_CHART_CONFIG = {
    chart: {
      type: "bar",
      height: (12 / 16) * 100 + "%"
    },
    title: {
      ...chartConfig.title,
      text: ""
    },
    xAxis: {
      type: "category",
      categories: [],
      title: {
        text: "Ministry/State",
        style: {
          color: "black"
        }
      },
      gridLineWidth: 0,
      labels: {
        style: {
          "font-weight": "400",
          width: "120px",
          "font-family": "mpb",
          "font-size": "9px",
          color: "#3e5574"
        }
      },
      min: 0,
      max: 6,
      scrollbar: {
        enabled: true
        //height: 30
      }
    },
    yAxis: {
      title: {
        text: "Pending Issues",
        style: {
          color: "black"
        }
      },
      gridLineWidth: 0,
      labels: {
        enabled: false
      },
      min: 0,
      reversedStacks: false
    },
    legend: {
      //reversed: true
      enabled: false
    },
    credits: {
      enabled: false
    },
    plotOptions: {
      series: {
        stacking: "normal",
        animation: true,
        borderRadiusTopLeft: 5,
        borderRadiusTopRight: 5,
        events: {
          legendItemClick: function(event) {
            event.preventDefault();
          }
        }
      }
    }
  };

  // extract data for charts
  let xSeriesArr = [];
  let series = [
    {
      name: "Project Planning",
      data: []
    },
    {
      name: "Land Acquisition",
      data: []
    },
    {
      name: "Clearance & Approvals",
      data: []
    },
    {
      name: "Construction",
      data: []
    },
    {
      name: "Commissioning",
      data: []
    }
  ];

  if (isValidArray(data)) {
    data.forEach((item, index) => {
      xSeriesArr.push(item.groupName);

      series.forEach(seriesItem => {
        let bucketCountDTOList = item.bucketCountDTOList;
        let selectedBucket =
          bucketCountDTOList &&
          bucketCountDTOList.length &&
          bucketCountDTOList.find(i => i.bucket === seriesItem.name);
        if (selectedBucket) {
          seriesItem.data[index] = selectedBucket.count;
        } else {
          seriesItem.data[index] = 0;
        }
      });
    });
  }
  // console.log("checkingmyyyystack==>>", series);
  BAR_CHART_CONFIG.xAxis.categories = xSeriesArr;
  BAR_CHART_CONFIG.series = series;

  return BAR_CHART_CONFIG;
};
